import React, { Component } from 'react';
import { connect } from 'react-redux';
import AliceCarousel from 'react-alice-carousel';
import Parser from 'react-html-parser';
import "react-alice-carousel/lib/alice-carousel.css";
import './slider.css';
import { fetchSlider } from '../../store/actions/homepageAction'
import { host } from '../../utils/globals';

class Slider extends Component {

    state = {
        currentIndex: 0
    }

    componentDidMount = () => {
        const { isFetched } = this.props.sliders;
        !isFetched && this.props.dispatch(fetchSlider());
    };

    onSlideChanged = (e) => this.setState({ currentIndex: e.item });

    galleryItems = () => {
        const { sliders } = this.props.sliders;
        const { isEnglish } = this.props;
        return sliders && sliders.map((d, i) => (
            <div key={i}>
                <figure>
                    <img
                        src={d.sliderImage ? `${host}${d.sliderImage}` : "/img/logo-blue.svg"}
                        className={d.sliderImage ? "img-responsive" : "img-responsive default-img"} alt="" />

                    <div className="container text-center">
                        <figcaption>
                            <h1>{isEnglish ? d.title : d.titleNepali}</h1>
                            <p>
                                {d.description && Parser(String(d.description.slice(0, 140)))}
                                {/*{isEnglish ? d.description && Parser(String(d.description.slice(0, 140))) : d.nepaliShortDesc && Parser(String(d.nepaliShortDesc.slice(0, 140)))}*/}
                                {d.description && d.description.length > 140 ? "..." : ""}
                            </p>
                        </figcaption>
                    </div>

                </figure>
            </div>
        ));
    }

    render() {
        return (
            <div id="headlines">
                <div className="owl-wrapper">
                    <AliceCarousel
                        duration={700}
                        autoPlay={true}
                        startIndex={0}
                        autoPlayInterval={4500}
                        autoPlayDirection="ltl"
                        dotsDisabled={true}
                        autoPlayActionDisabled={true}
                        items={this.galleryItems()}
                    />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        sliders: state.sliderList,
        isEnglish: state.changeLanguage.isEnglish
    }
}
export default connect(mapStateToProps)(Slider)